import type { DataDimensionProps } from "../../components/dimensions/DataDimension";
import { DataSource } from "../../components/dimensions/DataDimension/datasources";
import { DataDimensionValueType } from "../../components/dimensions/DataDimension/value/dimension.data.value";
import { DataDimensionValueLogicFunction } from "../../components/dimensions/DataDimension/value/dimension.data.value.logic";
import { VisualizationTypes } from "../../components/dimensions/DataDimension/visualization/formatHandler";
import { DimensionTypes } from "../../types/dimensions";

import type { DimensionFixtureExample } from ".";

export const logicFirstDim: DataDimensionProps = {
    id: "browseNode",
    configuration: {
        label: "Logic First Dimension",
        datasource: {
            type: DataSource.DIMENSIONS,
            optionalDependencies: true,
            settings: {
                ids: ["l1", "l2", "l3"],
            },
        },
        value: {
            type: DataDimensionValueType.LOGIC,
            rule: {
                function: DataDimensionValueLogicFunction.FIRST,
                args: ["l3", "l2", "l1"],
            },
        },
        visualization: {
            type: VisualizationTypes.NONE,
        },
    },
    dependencies: ["l1", "l2", "l3"],
    optional: true,
    type: DimensionTypes.DATA,
};

export const logicFirstRequestParameterDatasource: DataDimensionProps = {
    id: "browseNode",
    configuration: {
        label: "Logic First Dimension",
        datasource: {
            type: DataSource.REQUEST_PARAMETER,
            optionalDependencies: true,
            settings: {
                keys: ["l1_name", "l2_name", "l3_name"],
            },
        },
        value: {
            type: DataDimensionValueType.LOGIC,
            rule: {
                function: DataDimensionValueLogicFunction.FIRST,
                args: ["l3_name", "l2_name", "l1_name"],
            },
        },
        visualization: {
            type: VisualizationTypes.NONE,
        },
    },
    dependencies: ["l1", "l2", "l3"],
    optional: true,
    type: DimensionTypes.DATA,
};

export const DataDimensionValueLogicFirstExample: DimensionFixtureExample = {
    id: "datadimension_value_logic_first",
    name: "Data dimension value logic first function",
    description: "Data dimension value logic first function",
    dimensions: [
        [
            {
                id: "l1",
                type: "static_dropdown",
                dependencies: [],
                configuration: {
                    items: [
                        {
                            value: "l1",
                            label: "l1",
                        },
                    ],
                    label: "l1",
                },
            } as any,
            {
                id: "l2",
                type: "static_dropdown",
                dependencies: [],
                configuration: {
                    items: [
                        {
                            value: "l2",
                            label: "l2",
                        },
                    ],
                    label: "l2",
                },
            } as any,
            {
                id: "l3",
                type: "static_dropdown",
                dependencies: [],
                configuration: {
                    items: [
                        {
                            value: "l3",
                            label: "l3",
                        },
                    ],
                    label: "l3",
                },
                optional: true,
            } as any,
            logicFirstDim,
        ],
    ],
};

export const DataDimensionValueLogicFirstRequestExample: DimensionFixtureExample =
    {
        id: "datadimension_value_logic_first_request_parameter",
        name: "Data dimension value logic first function with request parameter",
        description: "",
        dimensions: [
            [
                {
                    id: "l1",
                    type: "static_dropdown",
                    dependencies: [],
                    configuration: {
                        items: [
                            {
                                value: "l1_value",
                                label: "l1_label",
                            },
                        ],
                        label: "l1",
                    },
                } as any,
                {
                    id: "l2",
                    type: "static_dropdown",
                    dependencies: [],
                    configuration: {
                        items: [
                            {
                                value: "l2_value",
                                label: "l2_label",
                            },
                        ],
                        label: "l2",
                    },
                } as any,
                {
                    id: "l3",
                    type: "static_dropdown",
                    dependencies: [],
                    configuration: {
                        items: [
                            {
                                value: "l3_value",
                                label: "l3_label",
                            },
                        ],
                        label: "l3",
                    },
                    optional: true,
                } as any,
                logicFirstRequestParameterDatasource,
            ],
        ],
    };
